import { render, staticRenderFns } from "./HdsIcon.vue?vue&type=template&id=1172a19f&scoped=true&"
import script from "./HdsIcon.vue?vue&type=script&lang=ts&"
export * from "./HdsIcon.vue?vue&type=script&lang=ts&"
import style0 from "./HdsIcon.vue?vue&type=style&index=0&id=1172a19f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1172a19f",
  null
  
)

export default component.exports